var _path, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCakeDecor(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 450,
    height: 450,
    viewBox: "0 0 450 450",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1422_156480",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 450,
    height: 450
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0H450V450H0V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1422_156480)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M49.1707 433.096V316.02V433.096Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.1707 433.096V316.02",
    stroke: "#CED3E7",
    strokeWidth: 24,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400.829 316.02V433.096V316.02Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400.829 316.02V433.096",
    stroke: "#CED3E7",
    strokeWidth: 24,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.2015 262.199V296.188C38.2015 308.084 51.7375 316.448 64.7541 312.595L98.0348 302.742C119.792 296.301 143.409 296.301 165.166 302.742L191.435 310.519C213.192 316.959 236.809 316.959 258.565 310.519L284.834 302.742C306.59 296.301 330.208 296.301 351.965 302.742L385.246 312.595C398.262 316.448 411.798 308.084 411.798 296.188V262.199C411.798 250.931 401.235 241.797 388.202 241.797H61.7984C48.766 241.797 38.2015 250.931 38.2015 262.199Z",
    fill: "white",
    fillOpacity: 0.01,
    stroke: "#CED3E7",
    strokeWidth: 24,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.1836 433.096H436.816H13.1836Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.1836 433.096H436.816",
    stroke: "#CED3E7",
    strokeWidth: 24,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.41 241.722V145.987C145.41 139.433 140.099 134.12 133.547 134.12H104.055C97.5035 134.12 92.1922 139.433 92.1922 145.987V241.722H145.41Z",
    fill: "white",
    fillOpacity: 0.01,
    stroke: "#CED3E7",
    strokeWidth: 24,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.801 107.528V133.674V107.528Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.801 107.528V133.674",
    stroke: "#CED3E7",
    strokeWidth: 24,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.584 74.1631C145.584 88.9604 133.592 100.957 118.8 100.957C104.008 100.957 92.0176 88.9604 92.0176 74.1631C92.0176 59.3649 118.8 16.905 118.8 16.905C118.8 16.905 145.584 59.3649 145.584 74.1631Z",
    fill: "white",
    fillOpacity: 0.01,
    stroke: "#CED3E7",
    strokeWidth: 24,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.608 241.722V145.987C251.608 139.433 246.298 134.12 239.747 134.12H210.253C203.702 134.12 198.392 139.433 198.392 145.987V241.722H251.608Z",
    fill: "white",
    fillOpacity: 0.01,
    stroke: "#CED3E7",
    strokeWidth: 24,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225 107.528V133.674V107.528Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225 107.528V133.674",
    stroke: "#CED3E7",
    strokeWidth: 24,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.783 74.1631C251.783 88.9604 239.792 100.957 225 100.957C210.208 100.957 198.217 88.9604 198.217 74.1631C198.217 59.3649 225 16.905 225 16.905C225 16.905 251.783 59.3649 251.783 74.1631Z",
    fill: "white",
    fillOpacity: 0.01,
    stroke: "#CED3E7",
    strokeWidth: 24,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.808 241.722V145.987C357.808 139.433 352.496 134.12 345.945 134.12H316.452C309.901 134.12 304.59 139.433 304.59 145.987V241.722H357.808Z",
    fill: "white",
    fillOpacity: 0.01,
    stroke: "#CED3E7",
    strokeWidth: 24,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.199 107.528V133.674V107.528Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.199 107.528V133.674",
    stroke: "#CED3E7",
    strokeWidth: 24,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.983 74.1631C357.983 88.9604 345.991 100.957 331.199 100.957C316.407 100.957 304.416 88.9604 304.416 74.1631C304.416 59.3649 331.199 16.905 331.199 16.905C331.199 16.905 357.983 59.3649 357.983 74.1631Z",
    fill: "white",
    fillOpacity: 0.01,
    stroke: "#CED3E7",
    strokeWidth: 24,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCakeDecor);
export default __webpack_public_path__ + "static/media/cakeDecor.5160849074fc7fb14e9c00f7e1346bb2.svg";
export { ForwardRef as ReactComponent };